import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function AgencySelect({ id = '', pattern = '' }) {
  const dispatch = useDispatch();
  const {
    agencies: { records: agencies },
    adduser: {
      validations,
      values: { agency: currentAgency },
    },
  } = useSelector(store => store);

  function validate(value) {
    console.log('pattern: ', pattern);
    const matches = value.match(pattern) || [];
    return matches.length > 0;
  }

  function handleChange(e) {
    const { value } = e.target;
    const valid = validate(value);
    dispatch({ type: 'EDIT_ADD_USER', id, valid, value: Number(value) });
  }

  const valid = validations[id];

  return (
    <div className="form-group">
      <label className="font-weight-bold form-label" htmlFor="agency">
        Agency
      </label>
      <select
        id="agency"
        name="agency"
        className={`form-select border ${valid ? null : 'is-invalid'}`}
        onChange={(e) => handleChange(e)}
        type="select"
        value={currentAgency}
      >
        <option value="" />
        {agencies.map(agency => (
          <option value={agency.id} key={agency.id}>{agency.name}</option>
        ))}
      </select>
    </div>
  );
}
